import axios from 'axios';

export const playgroundApi = axios.create({
  baseURL: '/api/v1/playground/',
  headers: { 'Content-Type': 'application/json' },
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  withCredentials: true,
});
